export default {
  team: {
    sendVerification: "Bestätigungs-E-Mail senden",
    checkVerification: "E-Mail ist bestätigt",
    verificationSent: "Bestätigungs-E-Mail gesendet. Öffne den Link und kehre hierher zurück.",

    rsvpIdentity: "Melde dich mit der bestätigten E-Mail-Adresse deiner Gästeinladung an. Der RSVP-Zugriff gewährt keinen Zugang zum Organisationsteam.",
    rsvpNoMatch: "Keine aktive RSVP-Einladung für diese E-Mail-Adresse. Nutze das eingeladene Konto oder bitte den Veranstalter, die Adresse zu prüfen.",
    legacyLink: 'Dieser alte Link oder PIN gewährt keinen Teamzugriff mehr. Bitte den Eigentümer um eine Einladung an deine E-Mail-Adresse und öffne Erhaltene Einladungen.',
    switchAccount: 'Anderes Konto verwenden',
  "title": "Team und Zugriff",
  "description": "Wähle aus, wer bei diesem Event helfen darf und welche Bereiche zugänglich sind.",
  "myInvitations": "Erhaltene Einladungen",
  "ownerOnly": "Nur der Eigentümer kann das Team verwalten. Wähle dafür ein eigenes Event.",
  "invite": "Person einladen",
  "retry": "Erneut versuchen",
  "members": "Personen mit Zugriff",
  "owner": "Eigentümer",
  "noMembers": "Bisher hast nur du Zugriff. Lade jemanden ein, wenn du möchtest.",
  "editAccess": "Zugriff bearbeiten",
  "remove": "Zugriff entfernen",
  "invitations": "Einladungen",
  "noInvitations": "Keine ausstehenden Einladungen.",
  "pending": "Annahme ausstehend",
  "cancelled": "Zurückgezogen",
  "expired": "Abgelaufen",
  "cancelInvite": "Einladung zurückziehen",
  "guestAccess": "Was ist mit Gästen und alten Links?",
  "guestHelp": "Das Team hilft bei der Organisation. Dieser Zugriff versendet keine Gästeinladungen und verwaltet keine RSVP-Antworten. Alte PINs und Links gewähren keinen Zugriff auf das neue Teamsystem.",
  "legacy": "{{count}} alte Zugriffseinträge müssen geprüft werden. Lade vertrauenswürdige Personen erneut per E-Mail zu den benötigten Bereichen ein.",
  "unknownLegacy": "Alter Zugriff ohne verlässliche E-Mail-Adresse – bitte mit der Person klären.",
  "removeHelp": "Diese Person verliert den Zugriff auf das Event. Ihre bisherigen Beiträge bleiben erhalten.",
  "cancelHelp": "Die Einladung wird zurückgezogen. Wurde sie bereits angenommen, wird auch der Zugriff entfernt. Beiträge bleiben erhalten.",
  "loadError": "Die Zugriffe konnten nicht geladen werden. Bitte erneut versuchen.",
  "actionError": "Speichern fehlgeschlagen. Prüfe deine Verbindung und versuche es erneut.",
  "email": "E-Mail-Adresse",
  "role": "Zugriffsstufe",
  "view": "Kann ansehen",
  "edit": "Kann bearbeiten",
  "roleHelp": "Ansehen: nur lesen. Bearbeiten: Einträge hinzufügen und ändern. Nur der Eigentümer kann Einträge löschen oder Zugriffe verwalten.",
  "sections": "Welche Bereiche?",
  "tasks": "Aufgaben",
  "guests": "Gäste",
  "budget": "Budget",
  "timeline": "Zeitplan",
  "summary": "{{role}} · {{sections}} · {{event}}. Der Zugriff umfasst alle Einträge dieser Bereiche, auch zukünftige.",
  "selectSections": "Wähle mindestens einen Bereich. Das Budget wird nur geteilt, wenn du es auswählst.",
  "identityHelp": "Einladungen laufen nach 7 Tagen ab. Die Person muss sich mit dieser bestätigten E-Mail-Adresse anmelden. Eine Weiterleitung gewährt anderen keinen Zugriff.",
  "send": "Einladung senden",
  "sent": "Einladung gesendet. Den Status findest du unter Team und Zugriff.",
  "updated": "Zugriff aktualisiert.",
  "deliveryFailed": "Die Einladung wurde gespeichert, aber die E-Mail konnte nicht zugestellt werden. Die Person kann sich anmelden und Erhaltene Einladungen öffnen.",
  "signIn": "Anmelden, um Einladungen anzusehen",
  "verifyEmail": "Bestätige deine E-Mail-Adresse und melde dich erneut an, um Einladungen anzusehen.",
  "accept": "Einladung annehmen",
  "acceptError": "Die Einladung konnte nicht angenommen werden. Sie ist möglicherweise abgelaufen oder wurde zurückgezogen.",
  "back": "Zurück zur Übersicht",
  "sharedEvent": "Mit dir geteilt",
  "openSection": "{{section}} öffnen",
  "waiting": "Einladung angenommen. Event wird geladen…",
  "sectionDenied": "Dieser Bereich ist für dich nicht freigegeben. Bitte den Eigentümer, deinen Zugriff anzupassen."
},
  review: {
    "notificationDraft": "Passen Sie Ihre Einstellungen an und speichern Sie die Änderungen.",
    "markReadError": "Benachrichtigungen konnten nicht aktualisiert werden. Versuchen Sie es erneut."
},
  accountFlow: {
    "proTitle": "Ihr Tarif: Pro",
    "proHelp": "Verwalten Sie hier Ihre Veranstaltungen, Ihr Abonnement und Ihre Rechnungen.",
    "manageEvents": "Meine Veranstaltungen verwalten",
    "unsaved": "Nicht gespeicherte Änderungen",
    "instantPreferences": "Einstellungen werden sofort übernommen.",
    "comparePlans": "Tarife vergleichen",
    "activeEvent": "Aktuelle Veranstaltung",
    "openEvent": "Öffnen",
    "editDetails": "Details bearbeiten",
    "switchError": "Veranstaltung konnte nicht gewechselt werden. Versuchen Sie es erneut."
},
  organization: {
    "vendorOverview": "Dienstleisterübersicht",
    "grid": "Raster",
    "noVendors": "Keine passenden Dienstleister",
    "resetHelp": "Ändern Sie Ihre Suche oder setzen Sie die Filter zurück.",
    "seatingProgress": "{{placed}} platziert · {{remaining}} noch offen",
    "firstTable": "Erstellen Sie Ihren ersten Tisch",
    "tableHelp": "Fügen Sie einen Tisch hinzu oder erstellen Sie automatisch einen Sitzplan.",
    "addTable": "Tisch hinzufügen"
},
  workflow: {
    "scheduleExists": "Bereits vorhandene Schritte werden nicht erneut hinzugefügt.",
    "taskView": "Aufgabenansicht",
    "list": "Liste",
    "kanban": "Board",
    "noTasksMatch": "Keine passenden Aufgaben",
    "resetTaskHelp": "Ändere die Suche oder setze die Filter zurück, um deine Aufgaben zu sehen.",
    "previewSchedule": "Beispielablauf ansehen",
    "scheduleHelp": "Diese Hochzeitsvorlage ergänzt deinen bestehenden Ablauf um die folgenden Schritte. Zeiten und Beschreibungen kannst du danach anpassen.",
    "applySchedule": "Diese Schritte hinzufügen"
},
  journey: {
    "guestActions": "Gäste verwalten",
    "openSeating": "Sitzplan öffnen",
    "moreGuestActions": "Teilen, RSVP und mehr",
    "noGuestResults": "Keine passenden Gäste",
    "changeGuestSearch": "Ändere die Suche oder setze die Filter zurück, um deine Gäste zu sehen.",
    "firstGuestHelp": "Füge den ersten Gast hinzu oder importiere deine Liste aus einer CSV-Datei.",
    "estimatorOptional": "Die Schätzung hilft dir bei der Budgetplanung. Du kannst auch mit deinen Ausgaben beginnen und später zurückkommen.",
    "skipEstimator": "Zu den Ausgaben"
},
  planning: {
    "eyebrow": "Dein Planungsbereich",
    "description": "Behalte deine Prioritäten im Blick und plane in deinem Tempo.",
    "actions": "Planungsaktionen",
    "tasks": "Meine Aufgaben",
    "guests": "Gäste",
    "budget": "Budget",
    "pendingCount": "{{count}} offen",
    "completedCount": "{{count}} erledigt",
    "noDueDate": "Ohne Fälligkeitsdatum",
    "overdue": "Überfällig",
    "allDone": "Alles erledigt: Alle Aufgaben sind abgeschlossen."
},
  title: "Dashboard",
  mobileTitle: "Startseite",
  welcome: "Willkommen auf deinem Dashboard",
  welcomeBack: "Willkommen zurück, {{name}}",
  daysLeft: "{{count}} Tage bis zu deiner Hochzeit",
  daysLeftShort: "{{count}} Tage verbleibend",
  today: "Heute",
  tomorrow: "Morgen",
  yesterday: "Gestern",
  subtitle: "Plane deinen großen Tag stressfrei",
  guests: "Gäste",
  tasks: {
    title: "Aufgaben",
    pending: "{{count}} ausstehend",
    completed: "{{count}} erledigt",
    viewAll: "Alle anzeigen",
    empty: {
      title: "Plane deine Aufgaben",
      description: "Beginne mit der Organisation deiner Hochzeitsaufgaben",
      action: "Aufgaben erstellen"
    },
    noPending: "Keine ausstehenden Aufgaben",
    categories: {
      legal: "Verwaltung",
      venue: "Veranstaltungsort",
      other: "Andere",
      planning: "Planung",
      guests: "Gäste"
    }
  },
  budget: "Budget",
  vendors: "Dienstleister",
  timeline: {
    examples: {
      preparation: {
        title: "Vorbereitung"
      },
      ceremony: {
        title: "Zeremonie"
      },
      cocktail: {
        title: "Cocktail"
      },
      dinner: {
        title: "Abendessen"
      },
      party: {
        title: "Abend"
      }
    }
  },
  checklist: "Checkliste",
  settings: "Einstellungen",
  help: "Hilfe",
  logout: "Abmelden",
  noWedding: "Keine Hochzeit gefunden",
  createWedding: "Hochzeit erstellen",
  editWedding: "Hochzeit bearbeiten",
  deleteWedding: "Hochzeit löschen",
  confirmDeleteWedding: "Bist du sicher, dass du diese Hochzeit löschen möchtest?",
  weddingDeleted: "Hochzeit erfolgreich gelöscht",
  weddingCreated: "Hochzeit erfolgreich erstellt",
  weddingUpdated: "Hochzeit erfolgreich aktualisiert",
  countdown: {
    title: "Countdown",
    noDate: "Hochzeitsdatum nicht festgelegt",
    days: "{{count}} Tag",
    dayJ: "Tage",
    dayJ_zero: "Heute!",
    dayJ_one: "Tag",
    dayJ_other: "Tage",
    days_plural: "{{count}} Tage",
    hours: "{{count}} Stunde",
    hoursJ: "Stunden",
    hoursJ_zero: "Stunde",
    hoursJ_one: "Stunde",
    hoursJ_other: "Stunden",
    hours_plural: "{{count}} Stunden",
    minutes: "{{count}} Minute",
    minutesJ: "Minuten",
    minutesJ_zero: "Minute",
    minutesJ_one: "Minute",
    minutesJ_other: "Minuten",
    minutes_plural: "{{count}} Minuten"
  },
  progressWidget: {
    title: "Fortschritt",
    global: "{{percent}}% abgeschlossen",
    daysLeft: "{{count}} Tage verbleibend",
    tasks: "Aufgaben",
    budget: "Budget",
    guests: "Gäste",
    checklist: "Checkliste",
    noData: "Keine Daten verfügbar"
  },
  weatherWidget: {
    title: "Wetter",
    setLocation: "Standort festlegen",
    addWeather: "Wetter hinzufügen",
    searchReception: "Empfangsort suchen",
    noData: "Keine Wetterdaten verfügbar",
    humidity: "Luftfeuchtigkeit",
    rain: "Regen",
    currentConditions: "Aktuelle Bedingungen in {{location}}",
    historicalTitle: "Historische Daten",
    historicalNote: "Basierend auf Durchschnittswerten der Vorjahre"
  },
  timelineWidget: {
    title: "Zeitplan",
    subtitle: "{{count}} Ereignisse",
    empty: "Keine kommenden Veranstaltungen"
  },
  notifications: {
    title: "Benachrichtigungen",
    unread: "{{count}} ungelesen",
    unread_plural: "{{count}} ungelesen",
    allRead: "Alles aktuell",
    viewAll: "Alle anzeigen",
    markAsRead: "Als gelesen markieren",
    markAllAsRead: "Alle als gelesen markieren",
    empty: "Keine Benachrichtigungen",
    viewMore: "Mehr anzeigen"
  },
  description: "Verwalten Sie Ihre Hochzeit auf einen Blick",
  noEventSelected: "Kein Ereignis ausgewählt",
  gridView: "Rasteransicht",
  listView: "Listenansicht",
  usage: "Nutzung",
  progress: {
    daysLeft: "{{count}} Tage verbleibend"
  },
  "Arrivée des invités": "Ankunft der Gäste",
  "Cérémonie": "Zeremonie",
  Cocktail: "Cocktail",
  "Dîner": "Abendessen",
  "Soirée": "Abend",
  "Préparation": "Vorbereitung",
  budgetWidget: {
    title: "Budget",
    subtitle: "Übersicht über Ihr Budget",
    configure: "Konfigurieren Sie Ihr Budget, um Statistiken anzuzeigen",
    configureButton: "Konfigurieren"
  },
  vendorsWidget: {
    title: "Dienstleister",
    subtitle: "Verwalten Sie Ihre Dienstleister",
    addVendor: "Dienstleister hinzufügen",
    emptyTitle: "Kein Dienstleister",
    emptyDescription: "Beginnen Sie mit der Recherche und Kontaktaufnahme mit Ihren Dienstleistern",
    searchVendors: "Nach Dienstleistern suchen",
    total: "{{count}} Dienstleister",
    add: "Hinzufügen"
  },
  notificationsWidget: {
    title: "Benachrichtigungen",
    unread: "{{count}} ungelesen",
    viewAll: "Alle ansehen",
    markAsRead: "Als gelesen markieren",
    empty: "Keine Benachrichtigungen",
    allRead: "Alle Benachrichtigungen wurden gelesen"
  },
  account: {
    title: "Konto"
  },
  guestsWidget: {
    title: "Gäste",
    total: "Gesamt",
    manage: "Verwalten",
    responseRate: "Antwortrate",
    estimatedProgress: "Geschätzter Fortschritt",
    confirmed: "Bestätigt",
    pending: "Ausstehend",
    declined: "Abgelehnt",
    children: "Kinder",
    teens: "Jugendliche",
    emptyTitle: "Keine Gäste",
    emptyDescription: "Beginnen Sie mit der Erstellung Ihrer Gästeliste",
    addButton: "Gast hinzufügen"
  },
  errors: {
    loadingError: "Fehler beim Laden der Daten",
    noEventFound: "Kein Ereignis gefunden",
    markAsRead: "Fehler beim Markieren als gelesen"
  },
  widgets: {
    tasks: {
      title: "Aufgaben",
      emptyTitle: "Beginnen Sie mit der Organisation",
      emptyDescription: "Fügen Sie die ersten Aufgaben hinzu, um Ihre Hochzeit zu organisieren",
      addButton: "Aufgabe hinzufügen",
      completed: "Abgeschlossen",
      inProgress: "In Bearbeitung",
      pending: "Zu erledigen",
      overdue: "Überfällig"
    },
    guests: {
      title: "Gäste",
      emptyTitle: "Verwalten Sie Ihre Gäste",
      emptyDescription: "Beginnen Sie mit der Erstellung Ihrer Gästeliste",
      addButton: "Gast hinzufügen",
      confirmed: "Bestätigt",
      pending: "Ausstehend",
      declined: "Abgelehnt",
      total: "Gesamt"
    },
    budget: {
      title: "Budget",
      emptyTitle: "Verwalten Sie Ihr Budget",
      emptyDescription: "Beginnen Sie mit der Verfolgung Ihrer Ausgaben",
      addButton: "Ausgabe hinzufügen",
      spent: "Ausgegeben",
      remaining: "Verbleibend",
      total: "Gesamt",
      currency: "€"
    },
    timeline: {
      title: "Zeitleiste",
      emptyTitle: "Erstellen Sie Ihre Zeitleiste",
      emptyDescription: "Fügen Sie Schlüsselmomente Ihrer Hochzeit hinzu",
      addButton: "Ereignis hinzufügen",
      daysLeft: "{{count}} Tage verbleibend",
      today: "Heute",
      upcoming: "Kommend"
    }
  },
  checklistWidget: {
    title: "Checkliste",
    subtitle: "Ihr Fortschritt",
    noImportant: "Keine wichtige Aufgabe",
    empty: {
      title: "Keine Aufgabe",
      description: "Beginnen Sie mit der Erstellung Ihrer Checkliste",
      action: "Eine Liste erstellen"
    }
  },
  stats: {
    tasksCompleted: "Erledigte Aufgaben",
    guestsConfirmed: "Bestätigte Gäste",
    budgetSpent: "Budget ausgegeben",
    daysLeft: "Verbleibende Tage"
  },
  quickActions: {
    title: "Schnellaktionen",
    addTask: "Aufgabe hinzufügen",
    addGuest: "Gast hinzufügen",
    addExpense: "Ausgabe hinzufügen",
    addEvent: "Ereignis hinzufügen"
  },
  eventDetails: {
    title: "Ereignisdetails",
    subtitle: "{{count}} Detail(s) zu vervollständigen",
    complete: "Alle Details sind ausgefüllt!",
    partners: "Partnerinformationen",
    location: "Veranstaltungsort",
    budget: "Veranstaltungsbudget",
    highPriority: "Hohe Priorität",
    mediumPriority: "Mittlere Priorität",
    lowPriority: "Niedrige Priorität",
    partner1: "Partner 1",
    partner2: "Partner 2",
    venue: "Empfangsort",
    venuePlaceholder: "Schloss Versailles",
    address: "Adresse",
    addressPlaceholder: "Place d'Armes, 78000 Versailles",
    city: "Stadt",
    cityPlaceholder: "Versailles",
    totalBudget: "Gesamtbudget (€)",
    guestCount: "Geschätzte Anzahl an Gästen",
    edit: {
      partners: "Partner bearbeiten",
      location: "Veranstaltungsort bearbeiten",
      budget: "Budget bearbeiten"
    }
  }
};
